export const environment = {
  production: false,
  // url: 'https://apistg.fronterasky.com',
  //url: 'http://localhost:3001',
  // paypalcliend: 'AeFvD33GTTZDbH6TCSb9_zh_E6g9L6wChkU1iF9KUhiNCf-UT9wq5JZpPsaPfGZ91T6pjaqA4jQFyWfa'
  //url: 'https://frontera-api.herokuapp.com',
  url: 'https://api-frontera-app.herokuapp.com',
  paypalcliend: 'AUKNUu9bkoVkwtzU0Q11ciioGE8tEai17AXMtHwgpYkc4jG5Yn9c6cb3fhxsxjR6Kgpln8kG3h4DX4-V' // producción
};
